import type { MissingContentErrorConfiguration } from '@omnia/ui/src/lib/lumos-plus/types/missing-content-error'
import {
    ContentSection,
    ContentType,
    MissingContentError,
} from '@omnia/ui/src/lib/lumos-plus/types/missing-content-error'
import type { BrowsingConfiguration, SalesChannel } from '@vista-digital/lumos-cms-client'
import { getConfiguration } from './get-configuration'
/**
 * Gets the browsing configuration from the domain store.
 *
 * @param missingContentErrorConfig The configuration for missing content error. If no need for throwing error when configuration isn't present don't pass the missingContentErrorConfig object.
 * @returns Browsing configuration.
 */
export function getBrowsingConfiguration(
    missingContentErrorConfig: MissingContentErrorConfiguration
): BrowsingConfiguration<SalesChannel.Web>
export function getBrowsingConfiguration(): BrowsingConfiguration<SalesChannel.Web> | undefined
export function getBrowsingConfiguration(
    missingContentErrorConfig?: MissingContentErrorConfiguration
): BrowsingConfiguration<SalesChannel.Web> | undefined {
    const browsingConfiguration = getConfiguration()?.browsing
    if (missingContentErrorConfig && !browsingConfiguration) {
        throw new MissingContentError(
            missingContentErrorConfig.contentName,
            ContentSection.Browsing,
            ContentType.Configuration
        )
    }
    return browsingConfiguration
}
